import script from "./Integration.vue?vue&type=script&setup=true&lang=js"
export * from "./Integration.vue?vue&type=script&setup=true&lang=js"

import "./Integration.vue?vue&type=style&index=0&id=f4c66a70&lang=scss&scoped=true"
import "./Integration.vue?vue&type=style&index=1&id=f4c66a70&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4c66a70"]])

export default __exports__